@if (!util.loginloader.isLoading) {
	<div class="not-found-container">
		<div>
			<img src="./assets/img/kayit-bulunamadi.png" />
			<div class="not-found-text">
				<div>
					{{ 'no-results-found' | translate }}
				</div>
				@if (removeFilterText) {
					<div>
						{{ 'removeSomeFilters' | translate }}
					</div>
				}
			</div>
		</div>
	</div>
}
